import type { NewsFeedDoc, NewsItem, NewsSource } from "../models/news.js";

export function parseNewsSource(raw: unknown): NewsSource | undefined {
  const r = (raw ?? {}) as Record<string, unknown>;
  if (typeof r["id"] !== "string" || typeof r["feedUrl"] !== "string") return undefined;
  const kind =
    r["kind"] === "atom" || r["kind"] === "jsonfeed" || r["kind"] === "rss"
      ? r["kind"]
      : "rss";
  const out: NewsSource = {
    id: r["id"],
    name: typeof r["name"] === "string" ? r["name"] : r["id"],
    feedUrl: r["feedUrl"],
    kind,
  };
  if (typeof r["enabled"] === "boolean") out.enabled = r["enabled"];
  if (typeof r["language"] === "string") out.language = r["language"];
  if (typeof r["homepage"] === "string") out.homepage = r["homepage"];
  if (typeof r["logo"] === "string") out.logo = r["logo"];
  if (typeof r["category"] === "string") out.category = r["category"];
  if (typeof r["liveChannel"] === "string" && r["liveChannel"].trim()) out.liveChannel = r["liveChannel"].trim();
  return out;
}

export function parseNewsItem(raw: unknown): NewsItem | undefined {
  const r = (raw ?? {}) as Record<string, unknown>;
  if (typeof r["id"] !== "string" || typeof r["title"] !== "string" || typeof r["url"] !== "string") {
    return undefined;
  }
  const out: NewsItem = { id: r["id"], title: r["title"], url: r["url"] };
  if (typeof r["description"] === "string") out.description = r["description"];
  if (typeof r["publishedAt"] === "string") out.publishedAt = r["publishedAt"];
  if (typeof r["source"] === "string") out.source = r["source"];
  if (typeof r["image"] === "string") out.image = r["image"];
  if (typeof r["category"] === "string") out.category = r["category"];
  return out;
}

export function parseNewsFeedDoc(raw: unknown): NewsFeedDoc {
  const r = (raw ?? {}) as Record<string, unknown>;
  const rawSources = Array.isArray(r["sources"]) ? (r["sources"] as unknown[]) : [];
  const rawOpen = Array.isArray(r["open"]) ? (r["open"] as unknown[]) : [];
  const out: NewsFeedDoc = {
    live: Boolean(r["live"] ?? false),
    version: typeof r["version"] === "string" ? r["version"] : "",
    sources: rawSources
      .map(parseNewsSource)
      .filter((s): s is NewsSource => s !== undefined),
  };
  if (rawOpen.length > 0) {
    out.open = rawOpen
      .map(parseNewsItem)
      .filter((n): n is NewsItem => n !== undefined);
  }
  return out;
}
